<template>
    <main>

        <div class="row">
            <div class="col-md-6">
                <div class="titles">
                    <h2 class="uppercase"><b><i class="fa fa-cogs"></i> Cadastre as tags</b></h2>
                </div>
            </div>
            <div class="col-sm-6">
                <button class="btn-large-40 btn-success uppercase pull-right" @click="openCreate()">
                    Criar
                </button>
            </div>
            <div class="col-sm-12">

                <div class="table-responsive standard-table header-cinza">
                    <table>
                        <thead>
                            <tr>
                                <th>Tag</th>
                                <th class="text-center" width="150"><i class="fa fa-cog"></i></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in result.items" v-bind:key="item.tagJobsId" class="animated fadeIn">
                                <td>{{item.tagJobs.nome}}</td>

                                <td class="text-center">
                                    <button type="button" class="btn btn-sm btn-danger" v-b-tooltip title="Remover" @click="openRemove(item)">
                                        <i class="fa fa-trash-o"></i>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

        </div>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogCreate" :hide-footer="true" title="Adicionar">
            <form-create v-if="dialogCreate" :questao-id="questaoId" @on-saved="onSaved()" @on-back="hideAll()" />
        </b-modal>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogRemove" title="Confirmação">
            <p>Tem certeza que deseja remover esta tag?</p>
            <div slot="modal-footer">
                <button class="btn btn-sm btn-danger" @click="executeRemove()">
                    Remover
                </button>
            </div>
        </b-modal>

    </main>

</template>
<script>

    import base from '@/common/base.js'
    import { Api } from '@/common/api'

    import formCreate from './form-create'

    export default {
        name: 'questaotagjobs',
        mixins: [base],
        components: { formCreate },
        props: { questaoId: Number },
        data() {
            return {

                resources: {
                    filter: 'questaotagjobs',
                    remove: 'questaotagjobs'
                },

                dialogRemove: false,
                dialogCreate: false,

                model: {},
                filter: {
                    pageSize: 50,
                    pageIndex: 1,
                    isPagination: true,
                },

                result: {
                    total: 0,
                    items: []
                }
            }
        },
        methods: {
            openCreate: function () {
                this.dialogCreate = true;
            },
            onSaved: function () {
                this.hideAll();
                this.executeLoad();
            },
            hideAll: function () {
                this.dialogCreate = false;
                this.dialogEdit = false;
                this.dialogRemove = false;
            },

            openRemove: function (model) {
                this.dialogRemove = true;
                this.model = model;
            },
            executeRemove: function (model) {
                if (model) this.model = model;
                new Api(this.resources.remove).delete(this.model).then(() => {
                    this.defaultSuccessResult("Item removido com sucesso");
                    this.hideAll();
                    this.executeLoad();
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            executeFilter: function (filter) {
                if (filter) this.filter = filter;
                this.executeLoad();
            },
            executePageChanged: function (index) {
                this.filter = this.defaultPageChanged(this.filter, index);
                this.executeLoad();
            },
            executeOrderBy: function (field) {
                this.filter = this.defaultOrderBy(this.filter, field);
                this.executeLoad();
            },
            executeLoad: function () {

                if (!this.questaoId) return;
                this.filter.questaoId = this.questaoId;

                this.showLoading();
                new Api(this.resources.filter).get(this.filter).then(data => {
                    if (data.summary) this.result.total = data.summary.total;
                    this.result.items = data.dataList;
                    this.hideLoading();
                }, (err) => {
                    this.failLoading();
                    if (err && err.data && err.data.errors) {
                        this.$eventHub.$emit('show-notification', {
                            type: 'error',
                            title: 'Atenção',
                            text: err.data.errors[0]
                        })
                    }
                });
            },

        },

        mounted() {
            this.executeFilter();
        }

    };
</script>